import { AppSubjectEnum } from '../../authz/enums/app-subject.enum';
import { CaslSubject } from '../../authz/decorators/casl-subject.decorator';
import { BaseDto } from '../../base/dtos/base.dto';
import { FileDto } from '../../files/dtos/file.dto';

/**
 * Vehicle make DTO for records
 */
@CaslSubject(AppSubjectEnum.VEHICLE)
export class VehicleMakeRecordDto extends BaseDto {
	uuid!: string;
	name!: string;
	notes?: string;
	externalReference?: string;
	files?: FileDto[];

	mobileTitle = (): string | null => {
		return `${this.name}`;
	};

	mobileSubtitle = (): string | null => {
		return '';
	};
}
